import React from 'react';
import {UserMenu} from './menu';
import _UserLayout from './_UserLayout.scss';
import {connect} from 'react-redux';

class UserLayout extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      active: ''
    }
  }

  componentDidMount() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  render() {
    return (
      <div className="center">
        <div className="row">
          <UserMenu active={this.props.active} businesses={this.props.businesses} auth={this.props.auth}/>
          <section className="user-container">
            {
              this.props.children
            }
          </section>
        </div>
      </div>
    );
  }
}

const bindStateToProps = state => {
  return {businesses: state.myBusinesses, auth: state.auth}
}

export default connect(bindStateToProps)(UserLayout);



// WEBPACK FOOTER //
// ./components/layouts/user/UserLayout.jsx